<!--
 * @Descripttion: 
 * @FilePath: /azg/src/views/register/store/components/RegisterForm.vue
 * @Author: 张兴业
 * @Date: 2020-12-08 22:32:11
 * @LastEditors: hl
 * @LastEditTime: 2026-07-14 15:22:43
-->

<template>
  <div class="form_box">
    <div class="title">{{ $G("现在入驻，即刻成为az全球购店主") }}</div>
    <el-form
      ref="form"
      class="form"
      :model="form"
      :rules="rules"
      @keyup.enter.native="onSubmit"
    >
      <phone-input v-model="form.phone" @prefixChange="prefixChange" />
      <code-ipnut
        v-model="form.code"
        :disabled-send="disabledSend"
        :sending="sending"
        @send="send"
      />
      <passwd-input v-model="form.passwd" />
      <el-form-item>
        <el-button
          :loading="loading"
          :disabled="disabledSubmit"
          type="primary"
          class="join"
          @click="onSubmit()"
        >
          立即入驻
        </el-button>
      </el-form-item>
      <agreement v-model="agree" />
      <!-- <had-registered /> -->
    </el-form>
  </div>
</template>

<script>
const PhoneInput = () => import("./PhoneInput");
const CodeIpnut = () => import("./CodeIpnut");
const PasswdInput = () => import("./PasswdInput");
const Agreement = () => import("./Agreement");
// const HadRegistered = () => import("./HadRegistered");
import { verifyPhone, verifyPasswd } from "@/utils/pattern.js";
import { isMobileTerminal } from "@/utils/pattern.js";

export default {
  components: { PhoneInput, CodeIpnut, PasswdInput, Agreement },
  data() {
    var validatePhone = (rule, value, callback) => {
      if (this.form.phone === "") {
        callback(new Error("请输入手机号"));
      } else {
        if (!verifyPhone(this.form.phone, this.prefix)) {
          callback(new Error("手机号码格式不正确"));
        } else {
          callback();
        }
      }
    };
    var validateCode = (rule, value, callback) => {
      if (this.form.code === "") {
        callback(new Error("请输入短信验证码"));
      } else {
        if (this.form.code.length !== 6) {
          callback(new Error("短信验证码不正确"));
        } else {
          callback();
        }
      }
    };
    var validatePasswd = (rule, value, callback) => {
      if (this.form.passwd === "") {
        callback(new Error("请设置密码"));
      } else {
        if (!verifyPasswd(this.form.passwd)) {
          callback(new Error("密码为6-12位数字或字母"));
        } else {
          callback();
        }
      }
    };
    return {
      loading: false,
      sending: false,
      prefix: "+86",
      agree: "0",
      form: {
        phone: "",
        code: "",
        passwd: "",
      },
      rules: {
        phone: [{ validator: validatePhone, trigger: "blur" }],
        code: [{ validator: validateCode, trigger: "blur" }],
        passwd: [{ validator: validatePasswd, trigger: "blur" }],
      },
    };
  },
  computed: {
    disabledSend() {
      const { phone } = this.form;
      if (verifyPhone(phone, this.prefix)) {
        return false;
      }
      return true;
    },
    disabledSubmit() {
      const { phone, code, passwd } = this.form;
      if (verifyPhone(phone, this.prefix)) {
        if (code.length === 6) {
          if (verifyPasswd(passwd)) {
            return false;
          }
        }
      }
      return true;
    },
  },
  methods: {
    prefixChange(prefix) {
      this.prefix = prefix;
    },
    send(callback) {
      const { phone } = this.form;
      if (!verifyPhone(phone, this.prefix)) {
        this.$message({
          message: "您输入的手机号格式不正确",
          type: "error",
        });
        return false;
      }
      const data = {
        phone,
        kind: "StoreRegister",
      };
      if (this.$appSource === 3) {
        data.areaCode = (this.prefix || "").replace("+", "");
      }
      const url = "/api/front/user/sendSms";
      this.sending = true;
      this.$request(url, {
        method: "POST",
        data,
      })
        .then((res) => {
          this.sending = false;
          if (res.code === 1) {
            this.$message({
              message: "验证码已发送到您的手机",
              type: "success",
            });
            callback();
          }
        })
        .catch(() => {
          this.sending = false;
        });
    },
    onSubmit() {
      if (this.agree === "0") {
        this.$message({
          message: "您尚未阅读并同意用户协议、隐私政策",
          type: "error",
        });
        return;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          const { phone, code, passwd } = this.form;
          const data = {
            phone,
            code,
            password: passwd,
            kind: "StoreRegister",
            websiteRegister: true,
          };
          const { inviteCode } = this.$route.query;
          if (inviteCode) {
            data.inviteCode = inviteCode;
            data.websiteRegister = false;
          }
          const url = "/api/front/store/storeRegister";
          this.loading = true;
          this.$request(url, {
            method: "POST",
            data,
          })
            .then((res) => {
              this.loading = false;
              if (res.code === 1100) {
                if (isMobileTerminal()) {
                  this.$dialog
                    .confirm({
                      title: "提示",
                      message: "该账号已注册，请前往App登录",
                    })
                    .then(() => {
                      this.goDownload();
                    })
                    .catch(() => {});
                } else {
                  this.$confirm("该账号已注册，请前往App登录", "提示", {
                    confirmButtonText: "前往",
                    cancelButtonText: "不，谢谢!",
                    type: "success",
                  })
                    .then(() => {
                      this.goDownload();
                    })
                    .catch(() => {});
                }
              }
              if (res.code === 1) {
                this.goDownload();
              }
            })
            .catch(() => {
              this.loading = true;
              // this.$router.push("result");
            });
        } else {
          return false;
        }
      });
    },
    goDownload() {
      if (isMobileTerminal()) {
        this.$router.push("result");
      } else {
        this.$router.push("/download/app/retail");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.form_box {
  background: white;
  padding: 60px 70px;
  border-radius: 30px;

  .title {
    font-size: 25px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    white-space: nowrap;
    text-align: left;
  }

  .form {
    margin-top: 48px;
    min-width: 440px;

    .join {
      width: 100%;
      margin-top: 40px;
    }
  }
}

@media only screen and (max-width: 768px) {
  .form_box {
    padding: 24px 16px;

    .title {
      white-space: normal;
    }

    .form {
      min-width: 320px;
      margin-top: 24px;

      .join {
        width: 100%;
        margin-top: 24px;
      }
    }
  }
}

@media only screen and (max-width: 320px) {
  .form_box {
    padding: 12px;

    .title {
      white-space: normal;
    }

    .form {
      min-width: 280px;
      margin-top: 10px;

      .join {
        width: 100%;
        margin-top: 0px;
      }
    }
    ::v-deep .had_registered {
      margin-top: 8px;
    }
  }
}
</style>
